import { FormActionType, FormActionTypes } from '@/types/shared';

export const isValidActionType = (action?: string): action is FormActionType =>
  FormActionTypes.includes(action as FormActionType);
